import { queryOptions } from '@tanstack/react-query';
import { fileInformationEntryTabQueryFunction } from '@/modules/FileDetail/queries/fileInformationEntryTab/fileInformationEntryTabQueryFunction.ts';

export const fileInformationEntryTabQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['information_entry_tabs', id],
    queryFn: () => fileInformationEntryTabQueryFunction(id),
    enabled: !!id,
  });
